export const LIGHT_PATH = 'assets/light/';
export const DARK_PATH = 'assets/images/';
